export default class HoerRoll{
	constructor(){
		this.initialize();
	}

	initialize(){
		const hoverrolls = document.querySelectorAll(".hoverRoll");
		hoverrolls.forEach(item=>{
			this.setHoverRoll(item);
		});
	}
	setHoverRoll(target){
		const texts = target.querySelectorAll(".hoverRoll__text");
		const labels = Array.from(texts).map(text=>{
			const l = text;
			const s = text.querySelector("span");
			const c = s.cloneNode(true); 
			return {
				label:l,
				span:s,
				copy:c
			};
		})
		const isCirclearrowbtn = (target.classList.contains("circlearrowbtn") || target.classList.contains("circlearrowbtn--wh"));
		let isHover = false;
		let isLeave = false;

		const animationEndHandler = ()=>{
			labels.forEach(label=>{
				label.copy.remove();
			})
			target.classList.remove("hover");
		};
		const enterHandler = ()=>{
			if(isHover) return;
			isHover = true;
			isLeave = false;
			target.classList.remove("hover");
			labels.forEach(label=>{
				label.label.appendChild(label.copy);
			});
			requestAnimationFrame(()=>{
				requestAnimationFrame(()=>{
					target.classList.add("hover");
				});
			});
		};
		const leaveHandler = ()=>{
			isHover = false;
			if(isCirclearrowbtn && !isLeave){
				isLeave = true;
				target.classList.remove("hover");
				labels.forEach(label=>{
					label.label.appendChild(label.copy);
				});
				requestAnimationFrame(()=>{
					requestAnimationFrame(()=>{
						target.classList.add("hover");
					});
				});
			}
		};
		const clickHandler = ()=>{
			target.classList.remove("hover");
			isHover = false;
		}


		target.addEventListener("click", clickHandler, false);
		labels.forEach(label=>{
			label.span.addEventListener("animationend", animationEndHandler, false);
		});
		if(!isTouch){
			target.addEventListener("mouseenter", enterHandler, false);
			target.addEventListener("mouseleave", leaveHandler, false);
		}
	}
	setCirclearrowHoverRoll(target){
		const texts = target.querySelectorAll(".hoverRoll__text");
		const labels = Array.from(texts).map(text=>{
			const l = text;
			const s = text.querySelector("span");
			const c = s.cloneNode(true); 
			return {
				label:l,
				span:s,
				copy:c
			};
		})
		let isHover = false;
		let isLeave = false;

		const animationEndHandler = ()=>{
			labels.forEach(label=>{
				label.copy.remove();
			})
			target.classList.remove("hover");
		};
		const enterHandler = ()=>{
			if(isHover) return;
			isHover = true;
			isLeave = false;
			target.classList.remove("hover");
			labels.forEach(label=>{
				label.label.appendChild(label.copy);
			});
			requestAnimationFrame(()=>{
				requestAnimationFrame(()=>{
					target.classList.add("hover");
				});
			});
		};
		const leaveHandler = ()=>{
			if(isLeave) return;
			isLeave = true;
			isHover = false;
			target.classList.remove("hover");
			labels.forEach(label=>{
				label.label.appendChild(label.copy);
			});
			requestAnimationFrame(()=>{
				requestAnimationFrame(()=>{
					target.classList.add("hover");
				});
			});
		};
		const clickHandler = ()=>{
			target.classList.remove("hover");
			isHover = false;
		}

		target.addEventListener("click", clickHandler, false);
		labels.forEach(label=>{
			label.span.addEventListener("animationend", animationEndHandler, false);
		});
		if(!isTouch){
			target.addEventListener("mouseenter", enterHandler, false);
			target.addEventListener("mouseleave", leaveHandler, false);
		}
	}
}